module.exports = __webpack_public_path__ + "media/WR Blob 2.6afcb88d.mp3";